<script>
import GuestDomentationMixin from '@/mixins/guestdocumentation'
import { helpers } from '@/helpers.js'

export default {
  name: 'GuestDomentationBrendanVacations',
  mixins: [GuestDomentationMixin],
  data () {
    return {
      modal: 0
    }
  },
  methods: {
    isInvalidContent (field = '') {
      return helpers.isInvalidContent(field)
    },
    printPage () {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
@import './print.scss';
</style>

<template>
  <div
    id="menu"
    class="body-page fp-viewing-home body"
    :class="{ 'modal-open': isModalToggle }"
  >
    <header
      class="page-header navbar page-header-drawer menu-right logo-left topmenu-right"
    >
      <button
        class="navbar-toggler site-menu-icon"
        id="navMenuIcon"
        :class="{ 'menu-visible': isMenuToggle }"
        @click="toggleMenu"

      >
        <span
          class="menu-icon menu-icon-line"
          :class="{ 'menu-visible': isMenuToggle }"
        >
          <span
            class="text show-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
          ></span>
          <span
            class="text hide-menu-visible"
            :class="{ 'menu-visible': isMenuToggle }"
            ></span
          >
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>
      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo" src="/guestdocumentation/brendan-vacations/img/logo.png" alt="Logo"/>
            </span>
          </a>
        </div>
      </div>
      <div
        class="all-menu-wrapper"
        id="navbarMenu"
        :class="{ 'menu-visible': isMenuToggle }"
      >
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#introduction" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('introduction')">Introduction</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#hotel" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('hotel')">Hotel List</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#freetime" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('freetime')">Free Time Add-ons</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <main
      class="page-main main-anim scrollpage-container"
      id="mainpage"

    >
      <!--BEGIN  HOME -->
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/brendan-vacations/img/bg-style-1.jpg)'}]"
        id="home"
      >
        <div class="overlay-home"></div>
        <div class="section-wrapper">
          <div class="section-content animated fadeInDown slow">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description text-center" >
                  <div class="cover-slider-description">
                   <div class="cover-calendar-location">
                     <h1 class="cover-header-description-title1">
                        <span class="location-cover" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                            <i class="fa fa-map-marker"></i>
                            <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}
                            </span>
                        </span>
                      </h1>
                      <h1 class="cover-header-description-title1">
                            <span>
                                <i class="icon fa fa-calendar"></i>
                                <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                                <i class="fa fa-arrow-right ml-3 mr-2"></i>
                            </span>
                            <span class="date-block">
                              <i class="icon fa fa-calendar"></i>
                              <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}
                            </span>
                        </span>
                      </h1>
                    </div>
                    <div class="cover-header-description-title2">
                      TRIP INFORMATION
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.itineraries">
                        <span>{{ d.itineraries.titleitinerary }}</span>
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.properties_opportunity && d.reference_number">
                        <small> {{ d.reference_number }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END HOME -->

      <!-- BEING INTRODUCTION -->
      <div class="arrow-border"></div>
      <div
        class="section info-area letter_after"
        data-section="introduction" id="introduction"

      >
        <div class="section-wrapper with-margin">
          <div class="single-info row order-mobile">
            <div class="col-lg-12">
              <div class="title-desc title-black no-print">
                <h2 class="h2">Your Celtic Story Starts Here…</h2>
                <img class="dividerLogo" src="/guestdocumentation/brendan-vacations/img/divider.png" />
              </div>
              <div class="title-desc anim-4 padding-container2"><button class="button_print btn btn-outline-white" @click="printPage"><i class="fa fa-print"></i>Print</button></div>
              <!--PRINT: INTRODUCTION-->
                  <table id="print-header" class="print-only">
                    <tbody>
                        <tr>
                          <td width="70%">
                              <h1 class="title_trip_info">TRIP<br> INFORMATION</h1>
                          </td>
                          <td width="10%"></td>
                          <td class="total-value" width="20%">
                              <div id="logo" class="logo_print">
                              <img class="light-logo" src="/guestdocumentation/brendan-vacations/img/logo.png" alt="Logo" width="240">
                              </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="70%" v-if="d && d.itineraries">
                            <div class="border-trip-name">
                              <h4>{{ d.itineraries.titleitinerary }}</h4>
                            </div>
                          </td>
                          <td width="10%"></td>
                          <td class="trip-code-section" width="20%">
                            <div class="print_info_it">
                              <p id="trip-code-number-section" v-if="d && d.properties_opportunity && d.reference_number">TRIP CODE<strong id="trip-code">{{ d.reference_number }}</strong></p>
                              <p id="trip-date-section" v-if="d && d.itineraries">TRIP DATE<strong id="trip-code">{{ d.itineraries.fromitinerary | custom-date }}</strong></p>
                              </div>
                          </td>
                        </tr>
                    </tbody>
                  </table>
                <!--PRINT: INTRODUCTION-->
              <div
                class="title-desc anim-4 paddig-container letter-information"
                v-html="d.guest_documentation.introduction">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END INTRODUCTION -->

      <!-- BEING ITINERARY -->
      <div
        class="section grey no-print" data-section="itinerary" id="itinerary">
        <div class="section-wrapper">
          <div class="section-wrapper">
            <div
              class="col-12 col-lg-12 anim cover-header-description-title2"
            >
              <div class="title-desc title-black">
                <h2 class="h2">Itinerary</h2>
                <img class="dividerLogo" src="/guestdocumentation/brendan-vacations/img/divider.png" />
                <h3 class="text-center title-name-itinerary" v-if="d && d.consumer_section">{{ d.consumer_section.trip_name }}</h3>
              </div>
            </div>

            <div class="row row-random grid-media-aside-text fade-3">
              <div
                class="border-card"
                :class="{
                  'col-md-6':
                    index != Object.keys(d.itineraries.days).length - 1 ||
                    (index === Object.keys(d.itineraries.days).length - 1 &&
                      Object.keys(d.itineraries.days).length % 2 === 0),
                  'col-md-12':
                    index === Object.keys(d.itineraries.days).length - 1 &&
                    Object.keys(d.itineraries.days).length % 2 !== 0
                }"
                v-for="(day, index) in d.itineraries.days"
                :key="index"
                @click="dayScrollTo(index)"
              >
                <div
                  class="card gallery-day"
                  data-toggle="modal"
                  data-target="#modal-fullscreen"
                >
                  <img
                    v-if="day.url_image_1200_725"
                    :src="day.url_image_1200_725"
                  />
                  <img
                    v-if="!day.url_image_1200_725"
                    src="/guestdocumentation/brendan-vacations/img/day-img.jpg"
                  />

                  <div class="info">
                    <div class="text-inside">
                      <h1>DAY {{ day.startday }}</h1>
                      <!-- <span>{{ Object.keys(d.itineraries.days).length % 2 != 0 }}</span> -->
                      <p class="subtittle" v-html="day.title"></p>
                      <p class="date">
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span v-if="day">{{
                          day.startdate | custom-date
                        }}</span>
                      </p>
                      <p class="location">
                        <i class="fa fa-map-marker mr-2"></i>
                        <span
                          v-if="
                            day && day.locations && Array.isArray(day.locations)
                          "
                          >{{ day.locations | custom-join('name') }}</span
                        >
                      </p>
                      <p
                        v-if="
                          day &&
                            day.textday &&
                            day.textday[0] &&
                            day.textday[0].textday
                        "
                      >
                        <span
                          v-html="
                            day.textday[0].textday.substring(0, 250) + '...'
                          "
                        ></span>
                        <a
                          href="javascript:void(0)"
                          data-toggle="modal"
                          class="underlineLink showMoreDay"
                          >Show more</a
                        >
                      </p>

                      <p v-if="day.meals">
                        <strong class="mr-1">MEAL(S):</strong>
                        <span>{{
                          day.meals | custom-join('mealsday')
                        }}</span>
                      </p>
                      <p v-if="day.accommodation">
                        <strong class="mr-1">HOTEL:</strong>
                        <span v-html="day.accommodation"></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--PRINT: YOUR TRAVEL ITINERARY-->
          <table id="days-box" class="print-only">
            <tbody>
                <tr :id="`day${index}`" v-for="(day, index) in d.itineraries.days" :key="index">
                  <td width="100%">
                      <h4 class="title-day-date">DAY {{ index + 1}} <span class="title-day" v-html="day.title"></span></h4>
                    <p class="dl-print">
                    <span v-if="day" class="date">{{ day.startdate | custom-date }}</span> / <span class="location" v-if="day && day.locations && Array.isArray(day.locations)" > <span>{{ day.locations | custom-join('name') }}</span>
                  </span>
                  </p>
                      <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                      <p v-if="day.meals">
                        <strong class="mr-1">MEAL(S):</strong>
                        <span>{{ day.meals | custom-join('mealsday') }}</span>
                      </p>
                      <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span>{{ day.accommodation}}</span>
                    </p>

                  </td>
                </tr>
            </tbody>
          </table>
        <!--PRINT: YOUR TRAVEL ITINERARY-->
      </div>
      <!-- END ITINERARY -->

      <!-- BEGIN MAP -->
      <div
        class="section fullscreen-md-off no-footer bg-image info-area"
        data-section="map"
        id="map"
        :style="[secondOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      secondOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/brendan-vacations/img/bg-style-2.jpg)'}]"
      >
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="h2 anim-2">Map</h2>
                   <img class="mb-4 dividerLogo" src="/guestdocumentation/brendan-vacations/img/divider-white.png" />
                </div>
              </div>

              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END MAP -->

      <!-- BEGIN HOTEL LIST -->
      <div
        class="section fullscreen-md-off no-footer grey"
        data-section="hotel"
        id="hotel">
        <div class="section-wrapper   with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc title-black">
                  <h2 class="h2 anim-2">Hotel List</h2>
                   <img class="mb-4 dividerLogo" src="/guestdocumentation/brendan-vacations/img/divider.png" />
                </div>
                <div>
                  <div class="section-info white table_pricing">
                    <div class="row">
                      <div class="col-12 col-md-12 anim">
                        <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1></div>
                        <div class="section-column amount-price">
                            <div v-html="d.guest_documentation.hotel_list"></div>
                        </div>
                      </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END HOTEL LIST -->

      <!--  FREE TIME ADDONS-->
      <div
        class="section fullscreen-md-off no-footer bg-image info-area"
        data-section="freetime"
        id="freetime"
        :style="[thirdOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      thirdOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/brendan-vacations/img/contact.jpg)'}]"
        v-if="!isInvalidContent(d.guest_documentation.optional_experience)"
      >
        <div class="section-wrapper   with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="title-desc">
                  <h2 class="h2 anim-2">Free Time Add-ons</h2>
                   <img class="mb-4 dividerLogo" src="/guestdocumentation/brendan-vacations/img/divider-white.png" />
                </div>
                <div>
                  <div class="section-info white table_pricing">
                  <div class="row">
                    <div class="col-12 col-md-12 anim">
                      <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Free Time Add-ons</h1></div>
                      <div>
                          <div v-html="d.guest_documentation.optional_experience"></div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--  FREE TIME ADDONS-->
      <footer>
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br />
            <img src="/guestdocumentation/brendan-vacations/img/logo-itp.png" width="80" />
          </div>
          <div class="detail">
            All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}
          </div>
        </div>
      </footer>
    </main>
    <div
      class="modal modal-fullscreen modalDays fade animated fadeIn show"
      id="modal-fullscreen"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
      :class="{ show: isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle"
    >
      <div class="overlaymd" @click="toggleModal"></div>
      <div class="section-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-hidden="true"
          @click="toggleModal"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-body">
            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days"
              :key="index"
            >
              <div class="row">
                <div class="col-md-12 cover-image section-text">
                  <img
                    v-if="day.url_image_1600_900"
                    :src="day.url_image_1600_900"
                  />
                  <img
                    v-if="!day.url_image_1600_900"
                    src="/guestdocumentation/brendan-vacations/img/day-img.jpg"
                  />
                  <div class="section_text_overlay">
                    <h1>DAY {{ index + 1 }}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                  </div>
                </div>
                <div class="col-md-12 section-text">
                  <div class="align-vcenter">
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{
                        day.startdate | custom-date
                      }}</span>
                    </p>
                    <p class="location mt-2">
                      <i class="fa fa-map-marker mr-2"></i>
                      <span
                        v-if="
                          day && day.locations && Array.isArray(day.locations)
                        "
                        >{{ day.locations | custom-join('name') }}</span
                      >
                    </p>
                    <p
                      v-if="
                        day &&
                          day.textday &&
                          day.textday[0] &&
                          day.textday[0].textday
                      "
                      v-html="day.textday[0].textday"
                    ></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">HOTEL:</strong>
                      <span>{{ day.accommodation }}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday">
                    <a class="down" href="#section02">
                      <span class="txt"
                        >DAY {{ Number(day.startday) + 1 }}</span
                      >
                    </a>
                  </footer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
